import React from "react";
import { HERO } from "@/mock";
import { ArrowRight } from "lucide-react";

const Hero = () => {
  return (
    <section id="top" className="relative overflow-hidden bg-[#0b0b0c]">
      <div
        className="absolute inset-0 opacity-[0.28]"
        style={{
          backgroundImage:
            "radial-gradient(1200px 500px at 80% 20%, rgba(201,162,74,0.35), transparent 60%), radial-gradient(800px 400px at 15% 90%, rgba(201,162,74,0.18), transparent 60%)",
        }}
      />
      <div
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='120' height='120'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9'/></filter><rect width='120' height='120' filter='url(%23n)' opacity='0.6'/></svg>\")",
        }}
      />

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 pt-14 pb-24 lg:pt-24 lg:pb-32">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <div className="text-[#c9a24a] uppercase text-[11px] tracking-[0.4em] mb-6">
              {HERO.eyebrow}
            </div>
            <h1 className="font-serif text-[#f4ead5] text-5xl md:text-7xl lg:text-[86px] leading-[0.98] tracking-tight">
              {HERO.titlePre}
              <br />
              <span className="italic text-[#c9a24a]">{HERO.titleAccent}</span>
            </h1>
            <p className="mt-8 text-[#a9a294] text-base md:text-lg max-w-xl leading-relaxed">
              {HERO.description}
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <a
                href={HERO.ctaPrimary.href}
                className="group inline-flex items-center gap-2 bg-[#c9a24a] hover:bg-[#b48d38] text-[#0b0b0c] px-7 py-4 text-[13px] uppercase tracking-[0.2em] font-medium transition-colors"
              >
                {HERO.ctaPrimary.label}
                <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
              </a>
              <a
                href={HERO.ctaSecondary.href}
                className="inline-flex items-center gap-2 border border-[#e9d9b0]/40 hover:border-[#c9a24a] text-[#e9d9b0] hover:text-[#c9a24a] px-7 py-4 text-[13px] uppercase tracking-[0.2em] font-medium transition-colors"
              >
                {HERO.ctaSecondary.label}
              </a>
            </div>

            <div className="mt-14 grid grid-cols-2 sm:grid-cols-4 gap-6 max-w-2xl">
              {HERO.badges.map((b) => (
                <div key={b.subtitle} className="border-t border-[#2a2724] pt-4">
                  <div className="font-serif text-[#f4ead5] text-2xl">{b.title}</div>
                  <div className="text-[#a9a294] text-xs uppercase tracking-[0.2em] mt-1">
                    {b.subtitle}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5 relative">
            <div className="relative aspect-[4/5] overflow-hidden rounded-sm">
              <img
                src="https://images.unsplash.com/photo-1509437142917-63dfe86dcbec?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
                alt="Crystal chandelier"
                className="absolute inset-0 w-full h-full object-cover scale-105 hover:scale-100 transition-transform duration-[1200ms] ease-out"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0b0b0c] via-transparent to-transparent" />
            </div>
            <div className="absolute -bottom-6 -left-6 hidden md:block bg-[#111112] border border-[#2a2724] p-5 max-w-[220px]">
              <div className="text-[#c9a24a] text-[10px] uppercase tracking-[0.3em]">Featured</div>
              <div className="font-serif text-[#f4ead5] text-lg mt-2 leading-tight">
                Celeste 8-Arm Crystal Chandelier
              </div>
              <div className="text-[#a9a294] text-sm mt-2">₹24,999</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
